module.exports = __webpack_public_path__ + "img/certificate04-3.3edf5eff.jpg";